import { createEventBus } from "@shared/features/eventBus/createEventBus";
import { VideoEvents } from "./video.events";

export const videoEventBus = createEventBus<VideoEvents>();
